export function parsePositiveInteger(raw: string): number | undefined {
  const trimmed = raw.trim();
  if (!/^\d+$/.test(trimmed)) return undefined;
  const value = Number(trimmed);
  return value > 0 ? value : undefined;
}

/** Compact token-count label for dense read-only display. Rounds to K/M so
 *  non-round limits (e.g. 262144, 1_050_000) render tidily instead of as raw
 *  digits: 262144 -> "262K", 1_050_000 -> "1.05M". The `value === undefined`
 *  check also narrows the type — `Number.isFinite` is not a TS type guard. */
export function formatTokenCount(value: number | undefined): string {
  if (value === undefined || !Number.isFinite(value) || value <= 0) return '—';
  if (value >= 1_000_000) return `${trimTrailingZeros(value / 1_000_000, 2)}M`;
  if (value >= 1_000) return `${Math.round(value / 1_000)}K`;
  return String(value);
}

function trimTrailingZeros(value: number, maxDecimals: number): string {
  return Number(value.toFixed(maxDecimals)).toString();
}
